<script setup>
const props = defineProps(['to','href','disabled','processing'])
</script>

<template>
    <a class="btn group" v-if="href" :href="href" target="_blank"><slot></slot></a>
    <router-link class="btn group" v-else-if="to" :to="{ name: to }">
        <slot></slot>
    </router-link>
    <button class="btn group" v-else :disabled="disabled"><i class="fas fa-circle-notch fa-spin" v-if="processing"></i><slot v-else></slot></button>
</template>

<style scoped>
.btn {
    @apply px-6 py-4 rounded bg-gradient-to-r from-lavendar-100 via-ruby-100 to-coral-100 uppercase font-bold text-white md:text-base text-sm
}

.btn-small {
    @apply px-4 py-3 text-sm
}
</style>